export default __webpack_public_path__ + "static/media/CMO.85bd1ac8.png";